export type UnhandledErrorEvent = {
	title: string
	description?: string
	cause?: unknown // Root exception to pass forward to Sentry
}

type Listener = (event: UnhandledErrorEvent) => void

const listeners = new Set<Listener>()

export function emitUnhandledError(event: UnhandledErrorEvent) {
	for (const listener of listeners) {
		listener(event)
	}
}

export function subscribeUnhandledError(listener: Listener) {
	listeners.add(listener)
	return () => listeners.delete(listener)
}
